import React, { FC } from "react";
import { Alert, AlertTitle, Box, Divider } from "@mui/material";
import { PropertiesCard } from "shared-ts-ui-properties-card";
import {
  Fireplace,
  FireplaceUpdateSpec,
} from "firefly-my-chimney-ts-building";
import {
  FireplaceCatalyticProperty,
  YesNoUnknownStringEnum,
} from "firefly-shared-ts-domain";
import { CustomerEnvironmentId } from "firefly-shared-ts-customer-environment";
import { FireplaceForm } from "./FireplaceForm";
import { useTranslation } from "react-i18next";

export interface FireplaceFormValues {
  name: string;
}

export interface FireplacePanelProps {
  environment: CustomerEnvironmentId;
  fireplace: Fireplace;
  onChange: (update: FireplaceUpdateSpec) => void;
}

export const FireplacePanel: FC<FireplacePanelProps> = (props) => {
  const { fireplace, environment } = props;
  const { t: tFireflyDomain } = useTranslation("firefly-shared-ts-domain");
  const { t } = useTranslation("my-chimney-ts-translations");

  return (
    <Box>
      <PropertiesCard
        header={{
          title: `${tFireflyDomain("Fireplace")}${
            fireplace.mcFields?.name != null
              ? `: ${fireplace.mcFields?.name ?? ""}`
              : ""
          }`,
          subtitle: t(
            "The fire department has recorded the following information about the fireplace"
          ),
        }}
        elevation={0}
      >
        <FireplaceCatalyticProperty
          value={fireplace.fields.catalytic}
          mode={"read"}
        />
      </PropertiesCard>
      {fireplace.fields.catalytic === YesNoUnknownStringEnum.Unknown && (
        <Alert severity={"warning"}>
          <AlertTitle>
            {t("Missing information about {{object}}", {
              object: tFireflyDomain("Clean-burning Fireplace"),
            })}
          </AlertTitle>
          Brannvesenet mangler informasjon om
        </Alert>
      )}
      {fireplace.mcFields != null && (
        <>
          <Divider />
          <FireplaceForm
            fireplace={fireplace}
            environment={environment}
            onChange={props.onChange}
          />
        </>
      )}
    </Box>
  );
};
